import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'motn-image-card',
    templateUrl: './image-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./image-card.component.scss'],
})
export class ImageCardComponent implements OnInit {
  @Input() imgSrc: string = '';
  @Input() title: string = '';
  @Input() subtitle: string = '';

  constructor() {
  }

  ngOnInit(): void {
  }

}
